import React from 'react';
import { changeState } from '@teammo/teammo-general-utils';

// Components
import { Input } from 'reactstrap';
import Button from 'app/components/general/Button';
import IconButton from 'app/components/general/IconButton';

// Misc
import CancelIcon from 'app/images/icons/cancel.svg';
import validateInput from './EditTeamMemberRowValidator';

interface IEditTeamMemberRowProps {
  fullName: string;
  email: string;
  mobile: string;
  isLoading: boolean;
  updateTeamMember: any;
  cancelTeamMember: any;
  deleteTeamMember: any;
  errors: any;
  teamMemberId: string;
}

interface IEditTeamMemberRowState {
  fullName: string;
  email: string;
  mobile: string;
  errors: any;
}
export default class EditTeamMemberRow extends React.Component<IEditTeamMemberRowProps, IEditTeamMemberRowState> {
  static defaultProps: IEditTeamMemberRowProps = {
    fullName: undefined,
    email: undefined,
    deleteTeamMember: undefined,
    mobile: undefined,
    updateTeamMember: undefined,
    cancelTeamMember: undefined,
    errors: {},
    isLoading: false,
  };

  state: IEditTeamMemberRowState = {
    fullName: this.props.fullName || '',
    email: this.props.email || '',
    mobile: this.props.mobile || '',
    errors: [],
  };

  isValid(): boolean {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }

    return isValid;
  }

  handleChange = (e): void => {
    this.setState(changeState(this.state, e.target));
  };

  handleCancel = (): void => {
    this.props.cancelTeamMember();
  };

  handleDelete = (e): void => {
    e.preventDefault();
    e.stopPropagation();

    this.props.deleteTeamMember({ id: this.props.teamMemberId });
  };

  handleSubmit = (e): void => {
    e.preventDefault();

    if (this.isValid()) {
      this.props.updateTeamMember({
        id: this.props.teamMemberId,
        fullName: this.state.fullName,
        email: this.state.email,
        mobile: this.state.mobile,
      });
    }
  };

  render(): React.ReactNode {
    return (
      <div className="row content-row add-team-member-row">
        <div className="col col-12 col-sm-3">
          <Input
            onChange={this.handleChange}
            name="fullName"
            placeholder="Full name"
            aria-label="Full name"
            autoFocus
            value={this.state.fullName}
          />
        </div>

        <div className="col col-12 col-sm-2">
          <Input
            onChange={this.handleChange}
            name="mobile"
            value={this.state.mobile}
            placeholder="Mobile"
            aria-label="Mobile"
          />
        </div>

        <div className="col col-12 col-sm-3">
          <Input
            onChange={this.handleChange}
            name="email"
            value={this.state.email}
            placeholder="Email (Optional)"
            aria-label="Email (Optional)"
          />
        </div>

        <div className="col col-12 col-sm-4 btn-flex-group">
          <div className="btn-flex-container thin-margin">
            <Button
              className="btn-thin btn-success"
              isLoading={this.props.isLoading}
              onClick={this.handleSubmit}
            >
              Save
            </Button>
            <IconButton
              icon={CancelIcon}
              className="cancel-icon btn btn-thin btn-2 btn-thinner-padding margin-left-10"
              onClick={this.handleCancel}
            />
            <Button
              className="btn-2 btn-thinner btn-thin-padding"
              onClick={this.handleDelete}
            >
              Delete
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
